// /src/pages/admin/AddProjectPage.tsx
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

// Firebase services
import { addProject } from "../../lib/firebase/firestore";
import { Layout } from "../../types"; // Import the Layout enum

export const AddProjectPage = () => {
  const navigate = useNavigate();

  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [tags, setTags] = useState("");
  const [year, setYear] = useState("");
  const [coverImageUrl, setCoverImageUrl] = useState("");

  // Initialize sections with type-safe Layout
  const [sections, setSections] = useState<
    Array<{ heading: string; text: string; imageUrl: string; layout: Layout }>
  >([{ heading: "", text: "", imageUrl: "", layout: "full-width" }]);

  const [loading, setLoading] = useState(false);

  const handleSectionChange = (index: number, field: string, value: string) => {
    const updatedSections = [...sections];
    updatedSections[index] = {
      ...updatedSections[index],
      [field]: field === "layout" ? (value as Layout) : value,
    };
    setSections(updatedSections);
  };

  const addSection = () => {
    setSections([
      ...sections,
      { heading: "", text: "", imageUrl: "", layout: "full-width" },
    ]);
  };

  const removeSection = (index: number) => {
    const updatedSections = sections.filter((_, i) => i !== index);
    setSections(updatedSections);
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!coverImageUrl) return alert("Please enter a cover image URL");

    setLoading(true);

    try {
      await addProject({
        title,
        description,
        coverImageUrl,
        tags: tags.split(",").map((t) => t.trim()),
        year: parseInt(year),
        contentSections: sections,
      });

      navigate("/admin/projects");
    } catch (error) {
      console.error("Error adding project:", error);
      alert("Failed to add project");
    }

    setLoading(false);
  };

  return (
    <div style={{ padding: "2rem" }}>
      <h2>Add New Project</h2>
      <form onSubmit={handleSubmit}>
        {/* Basic Fields */}
        <input
          type="text"
          placeholder="Title"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          required
          style={{ width: "100%", marginBottom: "1rem", padding: "0.5rem" }}
        />

        <textarea
          placeholder="Description"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          required
          style={{ width: "100%", marginBottom: "1rem", padding: "0.5rem" }}
        />

        <input
          type="text"
          placeholder="Tags (comma-separated)"
          value={tags}
          onChange={(e) => setTags(e.target.value)}
          required
          style={{ width: "100%", marginBottom: "1rem", padding: "0.5rem" }}
        />

        <input
          type="number"
          placeholder="Year"
          value={year}
          onChange={(e) => setYear(e.target.value)}
          required
          style={{ width: "100%", marginBottom: "1rem", padding: "0.5rem" }}
        />

        <input
          type="url"
          placeholder="Cover Image URL"
          value={coverImageUrl}
          onChange={(e) => setCoverImageUrl(e.target.value)}
          required
          style={{ width: "100%", marginBottom: "1rem", padding: "0.5rem" }}
        />

        {/* Content Sections */}
        <h3>Content Sections</h3>
        {sections.map((section, index) => (
          <div
            key={index}
            style={{
              border: "1px solid #ccc",
              padding: "1rem",
              marginBottom: "1rem",
            }}
          >
            <input
              type="text"
              placeholder="Heading"
              value={section.heading}
              onChange={(e) =>
                handleSectionChange(index, "heading", e.target.value)
              }
              style={{ width: "100%", marginBottom: "0.5rem" }}
            />
            <textarea
              placeholder="Text"
              value={section.text}
              onChange={(e) =>
                handleSectionChange(index, "text", e.target.value)
              }
              style={{ width: "100%", marginBottom: "0.5rem" }}
            />
            <input
              type="url"
              placeholder="Image URL"
              value={section.imageUrl}
              onChange={(e) =>
                handleSectionChange(index, "imageUrl", e.target.value)
              }
              style={{ width: "100%", marginBottom: "0.5rem" }}
            />
            <select
              value={section.layout}
              onChange={(e) =>
                handleSectionChange(index, "layout", e.target.value)
              }
              style={{ width: "100%", marginBottom: "0.5rem" }}
            >
              <option value="text-left">Text Left</option>
              <option value="text-right">Text Right</option>
              <option value="full-width">Full Width</option>
            </select>

            <button
              type="button"
              onClick={() => removeSection(index)}
              style={{
                marginTop: "0.5rem",
                backgroundColor: "#ff4d4d",
                color: "white",
                border: "none",
                padding: "0.3rem 0.6rem",
                cursor: "pointer",
              }}
            >
              Remove Section
            </button>
          </div>
        ))}

        <button
          type="button"
          onClick={addSection}
          style={{
            marginBottom: "2rem",
            backgroundColor: "#28a745",
            color: "white",
            border: "none",
            padding: "0.5rem 1rem",
            cursor: "pointer",
          }}
        >
          ➕ Add Section
        </button>

        {/* Submit Button */}
        <button
          type="submit"
          disabled={loading}
          style={{
            width: "100%",
            padding: "0.75rem",
            backgroundColor: "#000",
            color: "#fff",
            border: "none",
            cursor: "pointer",
          }}
        >
          {loading ? "Saving..." : "Save Project"}
        </button>
      </form>
    </div>
  );
};
